/**
 * شعار أفق الرسمي بالويب — مصدرٌ واحد لكل المواضع.
 *
 * رقم النسخة ضروري لا تجميلي: الخادم يُرسل الصور بـ `max-age=30 يوماً, immutable`،
 * فالمتصفح لا يعيد طلب ملفٍ بنفس الاسم شهراً كاملاً. تغيير الشعار مستقبلاً = تغيير
 * هذا الرقم (وما يقابله في index.html و landing.html).
 */
export const BRAND_LOGO = '/ufuq-logo-192.png?v=20260910'
